import SliderVideo from './slider-video';

export default class SliderVideoMobile extends SliderVideo {
    constructor(...args) {
        super(...args);

    }

    init(){
        super.init();

        this.dom.title = this.dom.component.querySelectorAll('.container-title');
        this.dom.line = this.dom.component.querySelectorAll('.line');

    }

    bind() {
        super.bind();

        //Set first class active
        this.dom.title[this.indexVideoPrev].classList.add('active');

        //Interval
        this.interval = setInterval(()=> {
            if (this.isPaused == false){
                this._intervalVideo(this.dom.title)
            }
        }, this.intervalDuration);

        //Event click title
        for (let i = 0; i < this.dom.title.length; i++) {
            this.dom.title[i].addEventListener('click', this._changeVideo.bind(this, i, this.dom.title));
        }

        //Event fullscreen video
        for (let i = 0; i < this.dom.video.length; i++) {
            this.dom.video[i].addEventListener("fullscreenchange", () => {
                this.isPaused = true;
            });
        }
    }

    _intervalVideo(){
        let index;

        if (this.indexVideoPrev === this.lengthSlide){
            index = 0
        }
        else {
            index = this.indexVideoPrev + 1;
        }

        // Remove previous video
        TweenMax.to(this.dom.containerVideo[this.indexVideoPrev], 0.5, {
            autoAlpha: 0
        });
        this.dom.title[this.indexVideoPrev].classList.remove('active');

        // Display next containerVideo
        TweenMax.to(this.dom.containerVideo[index], 0.5, {
            autoAlpha: 1
        });
        this.dom.title[index].classList.add('active');

        this.indexVideoPrev = index;
    }

    _changeVideo(index){

        this.isPaused = false;

        //Paused all video
        for (let i = 0; i < this.dom.video.length; i++) {
            this.dom.video[i].pause();
        }

        //Reset setInterval
        clearInterval(this.interval);
        this.interval = setInterval(()=>{
            if (this.isPaused == false){
                this._intervalVideo()
            }
        }, this.intervalDuration);

        // Remove previous containerVideo
        TweenMax.to(this.dom.containerVideo[this.indexVideoPrev], 0.5, {
            autoAlpha: 0
        });
        this.dom.title[this.indexVideoPrev].classList.remove('active');

        // Display next containerVideo
        TweenMax.to(this.dom.containerVideo[index], 0.5, {
            autoAlpha: 1
        });

        this.dom.title[index].classList.add('active');

        this.indexVideoPrev = index;
    }

    /*

    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/slider-video/slider-video.mobile.js